import React from 'react';
import styles from './ChecklistEducationBanner.less';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Icon, IconName } from 'app/common/components/controls';

const format = forTemplate('checklist_education_banner');

interface ChecklistEducationBannerProps {
  onDismiss: () => void;
}

export const ChecklistEducationBanner: React.FunctionComponent<ChecklistEducationBannerProps> = ({
  onDismiss,
}) => (
  <div className={styles.banner}>
    <h2 className={styles.heading}>{format('assign-people-and-dates')}</h2>
    <div className={styles.content}>
      {format('plus-see-all-your-assigned-items', {
        yourItems: (
          <a key="your-items" target="_blank" href="/my/tasks">
            {format('your-items')}
          </a>
        ),
      })}
    </div>
    <div className={styles.footer}>
      <a
        target="_blank"
        href="https://help.trello.com/article/942-assigning-people-and-due-dates-to-specific-checklist-items"
      >
        {format('learn-more')}
      </a>
    </div>
    <button className={styles.dismiss} onClick={onDismiss}>
      <Icon name={IconName.Close} />
    </button>
  </div>
);
